import { Equipment } from '../../shared/model/equipment';
import { SimCard } from '../../shared/model/sim-card';
import { EquipmentModel } from '../../shared/model/equipment-model';

export class Configuration {
  constructor(public id?,
              public simCard?: SimCard,
              public equipmentModel?: EquipmentModel,
              public creationDate?,
              public lastUpdateDate?,
              public isEditable?,
              public isVisible?,
              public canEdit?,
              public canView?,
              public editable?,
              public argosUser?,
              public observation?) {}
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/model/configuration.ts